import React from 'react';
import type { InboundCall, OutboundPatientCall } from '../../receptionist-call-logs';
import { InboundDrawer, OutboundPatientDrawer } from './CallDetailDrawer';

/** Renders whichever detail drawer matches the current selection (if any). */
export function CallDetailDrawerSwitch({
  inbound,
  outbound,
  onClose,
}: {
  inbound: InboundCall | null;
  outbound: OutboundPatientCall | null;
  onClose: () => void;
}) {
  if (inbound) return <InboundDrawer call={inbound} onClose={onClose} />;
  if (outbound) return <OutboundPatientDrawer call={outbound} onClose={onClose} />;
  return null;
}
